/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePartnerGroupV1Dto } from '../models/CreatePartnerGroupV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { OrderByPropertyDto } from '../models/OrderByPropertyDto';
import type { PartnerGroupFilterInnerV2Dto } from '../models/PartnerGroupFilterInnerV2Dto';
import type { PartnerGroupPaginatedV2Dto } from '../models/PartnerGroupPaginatedV2Dto';
import type { PartnerGroupSimplePaginatedV2Dto } from '../models/PartnerGroupSimplePaginatedV2Dto';
import type { PartnerGroupV1Dto } from '../models/PartnerGroupV1Dto';
import type { PatchPartnerGroupV1Dto } from '../models/PatchPartnerGroupV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PartnerGroupsService {
  /**
   * @param requestBody
   * @returns PartnerGroupV1Dto create entity
   * @throws ApiError
   */
  public static partnerGroupControllerV1CreateV1(
    requestBody: CreatePartnerGroupV1Dto,
  ): CancelablePromise<PartnerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/partner-groups',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns PartnerGroupV1Dto
   * @throws ApiError
   */
  public static partnerGroupControllerV1FindAllV1(): CancelablePromise<Array<PartnerGroupV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/partner-groups',
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1
   * @throws ApiError
   */
  public static partnerGroupControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partner-groups',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param uuid
   * @returns PartnerGroupV1Dto
   * @throws ApiError
   */
  public static partnerGroupControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<PartnerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/partner-groups/{uuid}',
      path: {
        uuid: uuid,
      },
    });
  }
  /**
   * @param uuid
   * @param requestBody
   * @returns PartnerGroupV1Dto
   * @throws ApiError
   */
  public static partnerGroupControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchPartnerGroupV1Dto,
  ): CancelablePromise<PartnerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/partner-groups/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param uuid
   * @returns PartnerGroupV1Dto
   * @throws ApiError
   */
  public static partnerGroupControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<PartnerGroupV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/partner-groups/{uuid}',
      path: {
        uuid: uuid,
      },
    });
  }
  /**
   * @param orderBy Array of PartnerGroupBaseV2Dto order by properties
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying PartnerGroups
   * @param searchString A search string to filter PartnerGroupBaseV2Dto by given values.
   * @param areaId Filter partner groups by area ID
   * @returns PartnerGroupPaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static partnerGroupControllerV2FindAllPaginatedV2(
    orderBy?: Array<OrderByPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: PartnerGroupFilterInnerV2Dto | null,
    searchString?: string | null,
    areaId?: string,
  ): CancelablePromise<PartnerGroupPaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/partner-groups',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        areaId: areaId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param orderBy Array of PartnerGroupBaseV2Dto order by properties
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying PartnerGroups
   * @param searchString A search string to filter PartnerGroupBaseV2Dto by given values.
   * @param areaId Filter partner groups by area ID
   * @returns PartnerGroupSimplePaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static partnerGroupControllerV2FindAllSimplePaginatedV2(
    orderBy?: Array<OrderByPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: PartnerGroupFilterInnerV2Dto | null,
    searchString?: string | null,
    areaId?: string,
  ): CancelablePromise<PartnerGroupSimplePaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/partner-groups/simple',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        areaId: areaId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
